import React, { useState, createElement } from 'react';
interface LeadFormProps {
  variant: 'residential' | 'commercial';
}
const WEBHOOK_URL = 'https://services.leadconnectorhq.com/hooks/oikZX4qRhVr8HxraIBVx/webhook-trigger/ueNRndPLSmbg6HUO87zm';
export function LeadForm({
  variant
}: LeadFormProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [selectedServices, setSelectedServices] = useState<string[]>([]);
  const [otherService, setOtherService] = useState('');
  const [consentTransactional, setConsentTransactional] = useState(false);
  const [consentMarketing, setConsentMarketing] = useState(false);
  const residentialServices = ['Driveway Cleaning', 'House Washing', 'Patio & Deck Cleaning', 'Roof Cleaning', 'Fence Cleaning', 'Window Cleaning', 'Trash Can Cleaning', 'Other'];
  const commercialServices = ['Building Exterior', 'Parking Lot Cleaning', 'Sidewalks & Walkways', 'Graffiti Removal', 'Fleet Washing', 'Dumpster Pad Cleaning', 'Other'];
  const services = variant === 'residential' ? residentialServices : commercialServices;
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);
    // Use hidden iframe + form to bypass CORS entirely
    const iframe = document.createElement('iframe');
    iframe.name = 'webhook_target';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = WEBHOOK_URL;
    form.target = 'webhook_target';
    const fields: Record<string, string> = {
      full_name: fullName,
      phone,
      email,
      address,
      service: selectedServices.map(s => s === 'Other' && otherService ? `Other: ${otherService}` : s).join(', '),
      consent_transactional: String(consentTransactional),
      consent_marketing: String(consentMarketing),
      source: `landing_page_${variant}`
    };
    Object.entries(fields).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    // Clean up after a short delay
    setTimeout(() => {
      document.body.removeChild(form);
      document.body.removeChild(iframe);
    }, 2000);
    setIsSuccess(true);
    setIsSubmitting(false);
  };
  if (isSuccess) {
    return <div className="bg-[#E8F4FD] border-2 border-[#0C8CE9] rounded-xl p-8 text-center shadow-lg" data-id="element-1">
        <div className="w-16 h-16 bg-[#0C8CE9] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-3">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-4" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-[#1B2A3D] mb-2" data-id="element-5">
          Thank You, {fullName.split(' ')[0] || 'Friend'}!
        </h3>
        <p className="text-[#1B2A3D] text-lg mb-2" data-id="element-6">
          Your quote request has been received.
        </p>
        <p className="text-[#1B2A3D] opacity-80" data-id="element-7">
          A member of our team will reach out within <strong data-id="element-8">1 hour</strong> to
          discuss your{' '}
          {selectedServices.length > 0 ? selectedServices.map(s => s === 'Other' && otherService ? `Other: ${otherService}` : s).join(', ') : 'project'}
          . Keep an eye on your phone!
        </p>
        <div className="mt-6 pt-4 border-t border-[#0C8CE9]/20" data-id="element-9">
          <p className="text-sm text-[#1B2A3D] opacity-70" data-id="element-10">
            Need immediate help? Call us at{' '}
            <a href="tel:4805998442" className="text-[#0C8CE9] font-bold hover:underline" data-id="element-11">
              (480) 599-8442
            </a>
          </p>
        </div>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-xl p-6 md:p-8 border border-gray-100" data-id="element-12">
      <div className="space-y-5" data-id="element-13">
        <div data-id="element-14">
          <label htmlFor="fullName" className="block text-sm font-bold text-[#1B2A3D] mb-1" data-id="element-15">
            Full Name *
          </label>
          <input type="text" id="fullName" required value={fullName} onChange={e => setFullName(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0C8CE9] focus:border-[#0C8CE9] outline-none transition-colors text-[#1B2A3D]" placeholder="John Doe" data-id="element-16" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-17">
          <div data-id="element-18">
            <label htmlFor="phone" className="block text-sm font-bold text-[#1B2A3D] mb-1" data-id="element-19">
              Phone Number *
            </label>
            <input type="tel" id="phone" required value={phone} onChange={e => setPhone(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0C8CE9] focus:border-[#0C8CE9] outline-none transition-colors text-[#1B2A3D]" placeholder="(480) 555-0123" data-id="element-20" />
          </div>
          <div data-id="element-21">
            <label htmlFor="email" className="block text-sm font-bold text-[#1B2A3D] mb-1" data-id="element-22">
              Email Address *
            </label>
            <input type="email" id="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0C8CE9] focus:border-[#0C8CE9] outline-none transition-colors text-[#1B2A3D]" placeholder="john@example.com" data-id="element-23" />
          </div>
        </div>

        <div data-id="element-24">
          <label htmlFor="address" className="block text-sm font-bold text-[#1B2A3D] mb-1" data-id="element-25">
            Property Address *
          </label>
          <input type="text" id="address" required value={address} onChange={e => setAddress(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0C8CE9] focus:border-[#0C8CE9] outline-none transition-colors text-[#1B2A3D]" placeholder="123 Main St, Phoenix, AZ" data-id="element-26" />
        </div>

        <div data-id="element-27">
          <p className="block text-sm font-bold text-[#1B2A3D] mb-2" data-id="element-28">
            Services Needed *
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-29">
            {services.map(s => <label key={s} className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg border cursor-pointer transition-colors ${selectedServices.includes(s) ? 'border-[#0C8CE9] bg-[#E8F4FD]' : 'border-gray-300 hover:border-gray-400'}`} data-id="element-30">
                <input type="checkbox" checked={selectedServices.includes(s)} onChange={e => {
              if (e.target.checked) {
                setSelectedServices(prev => [...prev, s]);
              } else {
                setSelectedServices(prev => prev.filter(item => item !== s));
              }
            }} className="w-4 h-4 rounded border-gray-300 text-[#0C8CE9] focus:ring-[#0C8CE9] accent-[#0C8CE9] flex-shrink-0" data-id="element-31" />
                <span className="text-sm text-[#1B2A3D]" data-id="element-32">{s}</span>
              </label>)}
          </div>
          {selectedServices.includes('Other') && <input type="text" value={otherService} onChange={e => setOtherService(e.target.value)} placeholder="Please describe the service you need..." className="w-full mt-2 px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0C8CE9] focus:border-[#0C8CE9] outline-none transition-colors text-[#1B2A3D] text-sm" data-id="element-33" />}
        </div>

        {/* Consent Checkboxes */}
        <div className="space-y-3 pt-2" data-id="element-34">
          <label className="flex items-start gap-3 cursor-pointer" data-id="element-35">
            <input type="checkbox" checked={consentTransactional} onChange={e => setConsentTransactional(e.target.checked)} className="mt-1 w-4 h-4 rounded border-gray-300 text-[#0C8CE9] focus:ring-[#0C8CE9] accent-[#0C8CE9] flex-shrink-0" data-id="element-36" />
            <span className="text-xs text-gray-600 leading-relaxed" data-id="element-37">
              I agree to receive emails and text messages related to this quote
              request. Message & data rates may apply.
            </span>
          </label>

          <label className="flex items-start gap-3 cursor-pointer" data-id="element-38">
            <input type="checkbox" checked={consentMarketing} onChange={e => setConsentMarketing(e.target.checked)} className="mt-1 w-4 h-4 rounded border-gray-300 text-[#0C8CE9] focus:ring-[#0C8CE9] accent-[#0C8CE9] flex-shrink-0" data-id="element-39" />
            <span className="text-xs text-gray-600 leading-relaxed" data-id="element-40">
              I'd like to receive future offers, tips, and updates from Blue
              Cactus Power Washing. You can unsubscribe anytime.
            </span>
          </label>
        </div>

        {error && <p className="text-sm text-red-600 font-medium text-center" data-id="element-41">
            {error}
          </p>}

        <button type="submit" disabled={isSubmitting} className="w-full bg-[#0C8CE9] hover:bg-[#0a7bc0] text-white font-bold text-lg py-4 px-8 rounded-lg transition-colors shadow-md flex justify-center items-center disabled:opacity-70" data-id="element-42">
          {isSubmitting ? 'Sending...' : 'Get My Free Quote'}
        </button>
      </div>
    </form>;
}